import { render, staticRenderFns } from "./ChannelNav.vue?vue&type=template&id=4d491e23&"
import script from "./ChannelNav.vue?vue&type=script&lang=js&"
export * from "./ChannelNav.vue?vue&type=script&lang=js&"
import style0 from "./ChannelNav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports